import * as authentication from "../actions/authentication";
import * as localization from "../actions/localization.js";

import {static as Immutable} from "seamless-immutable";

const defaultState = () => {
    return Immutable({
        downloading: false,
        hasData: false,
        data: {}
    });
};

/**
 * Localization reducer
 * @param {Object} state
 * @param {{type: string}} action
 * @return {*}
 */
export default function (state = defaultState(), action) {
    switch (action.type) {
    case localization.DOWNLOADING_LOCALIZATION:
        return Immutable.merge(state, {
            downloading: true,
            hasData: false
        });
    case localization.DOWNLOADED_LOCALIZATION:
        return Immutable.merge(state, {
            downloading: false,
            hasData: true,
            data: Immutable(action.data)
        });
    case localization.FAILED_TO_DOWNLOAD_LOCALIZATION:
        return Immutable.merge(state, {
            downloading: false,
            hasData: false
        });
    case authentication.LOGGED_OUT:
        return defaultState();
    default:
        return state;
    }
}